import * as interestProfilerActions from '../../actions/assessments/interestProfiler'
import * as h2Api from '../../h2Api'

const initialState = {
  currentQuestion: 1,
  instructionPageNumber: 1,
  popupOpen: false,
  requireConfirmation: false
}
const interestProfiler = (state = initialState, action) => {
  switch (action.type) {
    case interestProfilerActions.LOAD_IP_DATA:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          ...action.restCall.result
        }
      }

      return state

    case interestProfilerActions.RESPOND_IP:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log(action.restCall.result)
        const rId = action.restCall.result.number
        const nResponses = state.responses
        const r = nResponses.find(r => r.number === rId)

        r.response = action.restCall.result.response
        r.isAnswered = action.restCall.result.response >= 0

        return {
          ...state,
          responses: nResponses
        }
      }

      return state

    case interestProfilerActions.CHOOSE_VERSION:
      console.log(action.restCall)

      return {
        ...state,
        popupOpen: false,
        ...action.restCall.result
      }

    case interestProfilerActions.CANCEL_NEW_IP:
      return {
        ...state,
        popupOpen: false
      }

    case interestProfilerActions.NEW_IP:
      return {
        ...state,
        popupOpen: true,
        requireConfirmation: state.responses && state.responses.find(r => r.response > 0)
      }

    case interestProfilerActions.CONFIRM_OVERWRITE:
      return {
        ...state,
        requireConfirmation: false
      }

    case interestProfilerActions.ADVANCE_IP:
      return {
        ...state,
        currentQuestion: action.pageId
      }

    default:
      return state
  }
}

export default interestProfiler
